import React from 'react';
import './CSS/ContactUs.css'; // Make sure to create and style this CSS file

function ContactUs() {
  return (
    <div className="contact-us">
      <h1>Contact Us</h1>
      <div className="contact-info">
        <p>If you have any questions or need support, please reach out to us through the following contact details:</p>
        <div className="contact-item">
          <h2>Phone</h2>
          <p>+27 68 059 2688</p>
        </div>
        <div className="contact-item">
          <h2>Email</h2>
          <p><a href="mailto:sneakerproduction.9@gmail.com">sneakerproduction.9@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
